export default {
  inputs: {
    username: {
      en: "Username",
      pt: "Usuário",
    },
    password: {
      en: "Password",
      pt: "Senha",
    },
  },
  button: {
    en: "LOGIN",
    pt: "ENTRAR",
  },
  span: {
    forgetPassword: {
      en: "Forget password ?",
      pt: "Esqueceu a senha ?",
    },
    spanRegister1: {
      en: "Don't have account? The ",
      pt: "Não tem uma conta? O ",
    },
    spanRegister2: {
      en: "it is made autommaticaly after insert your informations",
      pt: "é feito automaticamente ao inserir suas informações.",
    },
    register: {
      en: "register",
      pt: "registro",
    },
  },
};
